import { services } from '@ambita/ambita-components-core';

services.i18n.registerTranslations('cadastreReportCadastreSections', {
  nb: {
    titleSections: 'Seksjonssameie med adresser',
    sectionCadastre: 'Matrikkel',
    sectionMunicipality: 'Kommune',
    sectionStreet: 'Gateadresse',
    sectionHouseNumber: 'Husnr',
    sectionPostalAddress: 'Postadresse',
    sectionPurpose: 'Formål',
    sectionFraction: 'Sameiebrøk'
  },
  'en-us': {
    titleSections: 'Sections with addresses',
    sectionCadastre: 'Cadastre',
    sectionMunicipality: 'Municipality',
    sectionStreet: 'Street',
    sectionHouseNumber: 'House Nr',
    sectionPostalAddress: 'Postal address',
    sectionPurpose: 'Purpose',
    sectionFraction: 'Fraction'
  }
});
